export const RADIAN = Math.PI / 180

export const LABEL_OPTIONS_DEFAULT = {
  minValueHandle: 5,
  rangeBetweenLabelLine: 10,
  rangeBetweenPieAndLine: 5,
  firstLabelLineLength: 30,
  secondLabelLineLength: 40,
  yTextFromBottom: 5,
}

export const CHART_TOOLTIP = {
  wrapperStyle: {
    background: '#000000',
    opacity: 0.7,
    padding: 10,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    fontWeight: 500,
    zIndex: 10,
    outline: 'unset',
  },
  labelStyle: {
    fontStyle: 'italic',
    fontSize: 10,
    marginBottom: 5,
  },
  cursor: {
    stroke: '#555555',
    strokeWidth: 1,
    strokeDasharray: '3 3',
  },
}
